import type { ReactNode } from 'react';

export type TemplateType<TT> = (props: TT, children?: ReactNode | Array<ReactNode>) => React.JSX.Element;

export interface TemplateOutletProps<PT> {
  props: PT;
  template: TemplateType<PT>;
  children?: ReactNode | Array<ReactNode>;
}

export default function TemplateOutlet<T>({ props, template, children }: TemplateOutletProps<T>) {
  return template(props, children);
}
